import { schema } from 'normalizr';

const people = new schema.Entity('people');

export default people;
